import { Button, Popconfirm, Popover } from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';

import { faKey, faShoppingBasket, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { UPDATE_DIRECT_OFFER } from 'Util/mutations';

function PopOverDetails({
    data = {},
    add = false,
    onSubmit,
    children
}) {
    const history = useHistory()
    const inputRef = useRef();

    const [oqInput, setOqInput] = useState(null)
    const [visible, setVisible] = useState(false)
    const [editQty, setEditQty] = useState(false)

    const isDisabled = _.isNull(oqInput) || _.isEmpty(oqInput.toString()) || parseInt(oqInput) < 1 || parseInt(oqInput) < data.min_quantity || parseInt(oqInput) > data.avail_quantity || data.order_quantity >= data.avail_quantity || data.order_quantity + parseInt(oqInput) > data.avail_quantity

    const [updateDirectOffer] = useMutation(UPDATE_DIRECT_OFFER, {
        onCompleted() {
            setEditQty(false)
        },
        onError(e) { }
    });


    const handleCart = () => {
        history.push('/procurement/direct-sales/staging-basket')
    }

    const handleSubmit = (action) => {

        let order_quantity = data.order_quantity
        let avail_quantity = data.avail_quantity
        let min_quantity = data.min_quantity

        if (action === 'add') {
            order_quantity = data.order_quantity + parseInt(inputRef.current.value);
            inputRef.current.value = "";
        }

        if (action === 'buy') {

            if (!_.isUndefined(inputRef.current)) {
                order_quantity = parseInt(inputRef.current.value)
            }

            avail_quantity = data.avail_quantity - order_quantity
            if (min_quantity > avail_quantity) {
                min_quantity = avail_quantity
            }
        }

        if (action === 'edit') {
            setEditQty(true)
            setTimeout(() => { inputRef.current.value = data.order_quantity }, 100)
            return null
        }

        if (action === 'save-qty') {

            updateDirectOffer({
                variables: {
                    id: data.id,
                    _set: { order_quantity: parseInt(inputRef.current.value) }
                }
            })

            return null
        }



        onSubmit({ action, data: { ...data, order_quantity, avail_quantity, min_quantity } })
        setVisible(false);

    }

    const content = () => (
        <div className='direct-offer-popover' >

            <div className='desc-wrapper'>
                <img src={data.image} />
                <div className='desc'>
                    <span className='title'>{data.species_name}</span>
                    <span>{`${data.harvest_method} from ${data.location}. ${data.preservation_method}`}</span>

                </div>
            </div>
            <div>
                <div className='row-wrapper'>
                    <label>Category:</label>
                    <span>{data.category}</span>
                </div>
                <div className='row-wrapper'>
                    <label>Preservation type:</label>
                    <span>{data.preservation_method}</span>
                </div>
                <div className='row-wrapper'>
                    <label>Country of origin:</label>
                    <span>{data.country_origin}</span>
                </div>
                <div className='row-wrapper'>
                    <label>Harvest method:</label>
                    <span>{data.harvest_method}</span>
                </div>
                <div className={`row-wrapper ${parseInt(oqInput) > data.avail_quantity ? 'error' : ''}`}>
                    <label>Available QTY:</label>
                    <span>{data.avail_quantity} / {data.quantity}</span>
                </div>
                <div className={`row-wrapper ${parseInt(oqInput) < data.min_quantity ? 'error' : ''}`}>
                    <label>Minimum order QTY:</label>
                    <span>{data.min_quantity}</span>
                </div>
                <div className='row-wrapper'>
                    <label>Unit price:</label>
                    <span>{data.price}/{data.unit}</span>
                </div>
                <div className='row-wrapper'>
                    <label>OffeType price:</label>
                    <span>{data.offer_type}</span>
                </div>
                <div className='row-wrapper'>
                    <label>Order quantity:</label>
                    {add && <input ref={inputRef} onChange={v => setOqInput(v.target.value)} type={"number"} />}

                    {!add && !editQty && <span>{oqInput ? oqInput : data.order_quantity}</span>}
                    {!add && editQty && <input ref={inputRef} onChange={v => setOqInput(v.target.value)} type={"number"} />}

                </div>
            </div>

            {
                add && <div className='pop-over-buttons-wrapper' >
                    <Button disabled={isDisabled} type="primary" className='add' onClick={() => handleSubmit('add')} > Add </Button>
                    {data.status === "open" && <Button disabled={isDisabled} type="primary" className='buy' onClick={() => handleSubmit('buy')} > Buy </Button>}
                    {data.status === "staged" && <Button type="primary" className='buy' onClick={() => handleCart('buy')} ><FontAwesomeIcon size="1x" icon={faShoppingBasket} /> ({data.order_quantity}) </Button>}
                </div>
            }

            {
                !add && <div className='pop-over-buttons-wrapper' >
                    <Button type="primary" className='edit' onClick={() => handleSubmit(editQty ? 'save-qty' : 'edit')} > {editQty ? 'Save' : 'Edit'}  </Button>
                    <Popconfirm
                        title="Are you sure you want to remove this item?"
                        onConfirm={() => handleSubmit('withdraw')}
                        okText="Yes"
                        cancelText="No"
                        placement='left'
                    >
                        <Button type="primary" className='cancel' > Withdraw </Button>
                    </Popconfirm>


                    <Button type="primary" className='buy' onClick={() => handleSubmit('buy')} > Buy </Button>
                </div>
            }


        </div>
    )

    if (_.isEmpty(data)) { return <></> }

    return <Popover
        placement='leftTop'
        trigger={'click'}
        onVisibleChange={visible => setVisible(visible)}
        visible={visible}
        content={content}
    >{children}</Popover>

}

PopOverDetails.propTypes = {
    data: PropTypes.object.isRequired,
    add: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node
}



export default PopOverDetails